/* eslint-disable no-cond-assign */
import { createElement, ReactNode } from "react";

export function parseHTMLTags(html: string) {
  try {
    const tagRegex =
      /<(meta|link|script|style)\b([^>]*?)(?:>([\s\S]*?)<\/\1\s*>|\/?>)/gi;
    const attrRegex = /([-\w]+)(?:=(?:"([^"]*)"|'([^']*)'|([^\s"'>]+)))?/g;
    const elements: ReactNode[] = [];
    let match: RegExpExecArray | null;
    let i = 0;

    while ((match = tagRegex.exec(html))) {
      const tag = match[1];
      const attrString = match[2];
      const innerHTML = match[3] || "";
      const props: Record<string, string | { __html: string }> = {};

      let attrMatch: RegExpExecArray | null;
      while ((attrMatch = attrRegex.exec(attrString))) {
        const [, attrName, doubleQuoted, singleQuoted, unquoted] = attrMatch;
        props[attrName] = doubleQuoted || singleQuoted || unquoted || "";
      }

      const key = `${tag}-${i}`;
      i += 1;

      if (tag === "script" || tag === "style") {
        props.dangerouslySetInnerHTML = { __html: innerHTML };
        elements.push(createElement(tag, { key, ...props }));
      } else {
        elements.push(createElement(tag, { key, ...props }));
      }
    }
    return elements;
  } catch (error) {
    console.error("parseHTMLTags error", error);
    return [];
  }
}
